import React from "react";

import { indexAct } from "../api/indexAct";

import { message, Spin } from "antd";

export default class Service extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: true,
      service: [],
    };
  }

  componentDidMount() {
    this.getService();
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    if (this.props.lang !== prevProps.lang) {
      this.getService();
    }
  }

  getService = () => {
    indexAct("GET_SERVICE", {}, "/").then((data) => {
      if (data.code === 200) {
        this.setState((state) => {
          state.loading = false;
          state.service = data.res;
          return state;
        });
      } else {
        message.error("შეცდომა!", 5);
      }
    });
  };

  render() {
    const { loading, service } = this.state;
    return (
      <>
        <div className="ant-segment" id="service">
          <div className="page-title-ribbon ribbon-color-1">
            <span className="page-title-ribbon-content">
              {" "}
              {
                this.props.info.ROUTES.find((el) => el.COMPONENT === "Service")
                  .PAGE_NAME
              }
            </span>
          </div>
          <div className="page-content">
            {loading ? (
              <Spin
                style={{
                  width: "100%",
                  height: "100%",
                }}
              />
            ) : (
              <div
                dangerouslySetInnerHTML={{
                  __html: service.SERVICE_DESCRIPTION,
                }}
              />
            )}
          </div>
        </div>
      </>
    );
  }
}
